import React from 'react';

import { ArrowRightIcon, ArrowUpIcon, InputIcon, IntroIcon, LoadingIcon, PauseIcon, PlayIcon } from '@/components/Icons';
import { AudioDetailDto } from '@/service/interface';
import { useAudioPlayerStore } from '@/state/audio-player-store';
import CoverDefaultSrc from '@/assets/cover-default.png';
import { metadataTypeMapWord } from '../HistoryInfo';
import { getUploadSignUrl } from '@/service';
import useGeneratorStore from '@/state/generator-store';

export const InputInfo = ({
  selectedSongDetail,
  fetchSongDetail,
}: {
  selectedSongDetail: AudioDetailDto;
  fetchSongDetail: (params: { id: string }) => void;
}) => {
  const { play, playAudioInfo, isLoading, isPlaying, pause } = useAudioPlayerStore();

  const { generatorForm } = useGeneratorStore();

  const isCurrentSong = playAudioInfo?.id === selectedSongDetail?.metadata?.upload_file_id;

  const ifExtended = !!selectedSongDetail?.metadata?.extendedIds?.length;

  const renderPlayIcon = () => {
    if (isCurrentSong) {
      if (isLoading) {
        return <LoadingIcon className="w-[20px] animate-spin" />;
      }
      if (isPlaying) {
        return <PauseIcon className="w-[20px] cursor-pointer" onClick={() => pause()} />;
      }
    }
    return (
      <PlayIcon
        className="w-[20px] cursor-pointer"
        onClick={async () => {
          const { data } = await getUploadSignUrl({ id: String(selectedSongDetail?.metadata?.upload_file_id) });
          const sign_url = data?.sign_url;
          if (sign_url) {
            play({
              id: selectedSongDetail?.metadata?.upload_file_id,
              url: sign_url,
              name: selectedSongDetail?.metadata?.upload_reimagine?.name,
            });
          }
        }}
      />
    );
  };
  const renderInputContent = () => {
    if (selectedSongDetail?.metadata?.upload_file_id) {
      return (
        <>
          <div className=" p-[12px] flex items-start gap-[8px] border-b border-jen-border">
            {renderPlayIcon()}
            <div className="whitespace-normal break-words break-all ">{selectedSongDetail?.metadata?.upload_reimagine?.name}</div>
          </div>
          <div className=" p-[12px] flex items-center gap-[8px]">
            <ArrowRightIcon />
            <div className="whitespace-normal break-words break-all ">{selectedSongDetail?.prompts}</div>
          </div>
        </>
      );
    }

    return (
      <div
        onClick={() => {
          generatorForm?.setValue('prompt', selectedSongDetail?.prompts);
        }}
        className=" cursor-pointer px-[7px] py-[12px] text-jen-size-heading-04 min-h-[32px]  pl-[12px] flex  items-center whitespace-normal break-words break-all "
      >
        {selectedSongDetail?.prompts}
      </div>
    );
  };
  return (
    <div className="  mt-[16px] mr-[8px] items-center ml-[16px] border border-jen-border rounded-lg">
      <div className="text-jen-content-tertiary text-[12px] font-pressura-mono  h-[32px] px-[7px] py-[12px] flex  items-center pl-[12px] gap-[8px] border-b border-jen-border">
        <InputIcon fillColor="currentColor" />
        TEXT INPUT
      </div>
      {renderInputContent()}
    </div>
  );
};
